export default function PHP_array_pop() {
  return (
    <div>
      <h1>PHP_array_pop</h1>
    </div>
  );
}
